// hooks/useEventsParams.js
import { useState, useEffect } from 'react';

// Fonction utilitaire pour déclencher un événement de mise à jour
const triggerEventsUpdate = () => {
  window.dispatchEvent(new CustomEvent('eventsParamsUpdated'));
};

const useEventsParams = () => {
  const [events, setEvents] = useState([]);
  const [eventsByCategory, setEventsByCategory] = useState([[], [], []]); // 3 catégories
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadEvents = async () => {
    try {
      setLoading(true);
      
      const response = await fetch('/api/parametres/events', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      const data = await response.json();
      setEvents(data.data?.events || []);
      setEventsByCategory(data.data?.eventsByCategory || [[], [], []]);

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const addEvent = async (eventData) => {
    try {
      const response = await fetch('/api/parametres/events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include',
        body: JSON.stringify(eventData)
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadEvents();
      triggerEventsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const updateEvent = async (id, eventData) => {
    try {
      const response = await fetch(`/api/parametres/events/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include',
        body: JSON.stringify(eventData)
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadEvents();
      triggerEventsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const deleteEvent = async (id) => {
    try {
      const response = await fetch(`/api/parametres/events/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }

      await loadEvents();
      triggerEventsUpdate();
      return { success: true };
      
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Écouter les événements de mise à jour + chargement initial
  useEffect(() => {
    loadEvents();
    
    // Écouter les mises à jour depuis d'autres composants
    const handleUpdate = () => {
      console.log('🔄 [useEventsParams] Mise à jour temps réel détectée');
      loadEvents();
    };
    
    window.addEventListener('eventsParamsUpdated', handleUpdate);
    
    return () => {
      window.removeEventListener('eventsParamsUpdated', handleUpdate);
    };
  }, []);

  return {
    events,
    eventsByCategory,
    addEvent,
    updateEvent,
    deleteEvent,
    loadEvents,
    loading,
    error
  };
};

export default useEventsParams;